var $header = document.querySelector("#header");

let loading = document.querySelector("#loading")
if (sessionStorage.getItem("loadedOnce")) {
    document.body.classList.add("loaded")
    loading.remove()
} else {
    sessionStorage.setItem("loadedOnce", true)
    window.addEventListener("load", () => {
        document.body.classList.add("loaded")

        setTimeout(() => {
            loading.remove()
        }, 4000)
    })
}

// Nav Toggle Button
document.getElementById("toggle").addEventListener('click', (e) => {
    $header.classList.toggle("is-open");
});

let body = document.body;

document.querySelectorAll("a, button, input, textarea, #instagram-feed a").forEach((node) => {
    node.addEventListener("mouseenter", addClassMedium)
    node.addEventListener("mouseleave", removeClassMedium)
})

function addClassMedium() {
    body.classList.add("is-medium");
}

function removeClassMedium() {
    body.classList.remove("is-medium");
}

document.querySelectorAll("#toggle, .btn-L, .logo_link").forEach((node) => {
    node.addEventListener("mouseenter", () => {
        body.classList.add("is-large");
    })
    node.addEventListener("mouseleave", () => {
        body.classList.remove("is-large");
    })
})

document.querySelectorAll(".btn-img, .modal, .instagram-sidecar, .instagram-video, .instagram-image, .modal-button").forEach((node) => {
    node.addEventListener("mouseenter", () => {
        body.classList.add("is-change");
    })
    node.addEventListener("mouseleave", () => {
        body.classList.remove("is-change");
    })
})

document.querySelectorAll(".instagram-sidecar, .instagram-video, .instagram-image, .modal-button").forEach((node) => {
    node.removeEventListener("mouseenter", addClassMedium)
    node.removeEventListener("mouseleave", removeClassMedium)
})

document.querySelectorAll(".single__innerContentsPriceBtn").forEach((node) => {
    node.addEventListener("mouseenter", () => {
        body.classList.add("is-none");
    })
    node.addEventListener("mouseleave", () => {
        body.classList.remove("is-none");
    })
})

document.querySelectorAll(".linkBtn").forEach((node) => {
    node.addEventListener("mouseenter", () => {
        document.querySelector(".header__innerNavBg").classList.add(node.dataset.hover)
    })
    node.addEventListener("mouseleave", (e) => {
        document.querySelector(".header__innerNavBg").classList.remove(node.dataset.hover)
    })
})

let icon = document.querySelector("#js-cursor")
document.querySelector("html").addEventListener("mousemove", (e) => {
    icon.style.opacity = "1"
    icon.style.top = (e.clientY - 60) + "px"
    icon.style.left = (e.clientX - 60) + "px"
})